// src/Button/Spinner.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function Spinner() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      style: { transform: "scaleX(-1)" },
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20",
            stroke: "url(#paint0_linear_674_4867)",
            strokeWidth: "2",
            strokeLinecap: "round"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 13.4571 19.6104 14.8233 18.9297 16",
            stroke: "url(#paint1_linear_674_4867)",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }
        ),
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "paint0_linear_674_4867",
              x1: "8",
              y1: "20",
              x2: "20.5",
              y2: "15.5",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#1C1D1E" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.382331", stopColor: "#1C1D1E" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.818132", stopColor: "#1C1D1E", stopOpacity: "0.36" }),
                /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#1C1D1E", stopOpacity: "0" })
              ]
            }
          ),
          /* @__PURE__ */ jsxs(
            "linearGradient",
            {
              id: "paint1_linear_674_4867",
              x1: "18",
              y1: "-4.5",
              x2: "11",
              y2: "17",
              gradientUnits: "userSpaceOnUse",
              children: [
                /* @__PURE__ */ jsx("stop", { stopColor: "#1C1D1E" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.703125", stopColor: "#1C1D1E", stopOpacity: "0.208333" }),
                /* @__PURE__ */ jsx("stop", { offset: "0.848958", stopColor: "#1C1D1E", stopOpacity: "0" }),
                /* @__PURE__ */ jsx("stop", { offset: "1", stopColor: "#1C1D1E", stopOpacity: "0" })
              ]
            }
          )
        ] })
      ]
    }
  );
}

export {
  Spinner
};
